import React, { useState, useEffect, useContext } from "react";
import FadeIn from "react-fade-in";
import { UserContext } from "../../../../storage/contexts/UserContext.js";
import axios from "axios";
import { GET_EAP_ITEMS } from "../../../../Routes.js";
import { generateURLOptions } from "../../../../URLOptions.js";

import { FaPhone } from "react-icons/fa6";
import CommonEAPCard from "../../../../InterstellrComponents/CommonEAPCard.jsx";
import EAPDetailsModal from "../../../../InterstellrModals/EAPDetailsModal.jsx";

const SupportConnect = () => {
  const { profile } = useContext(UserContext);

  const [featuredProvider, setFeaturedProvider] = useState({});
  const [supportProviders, setSupportProviders] = useState([]);

  const [eapOpen, setEapOpen] = useState(false);
  const [selectedEAP, setSelectedEAP] = useState(null);

  useEffect(() => {
    getEAPProviders();
  }, []);

  const getEAPProviders = async () => {
    await axios
      .get(GET_EAP_ITEMS, {
        headers: generateURLOptions(),
      })
      .then(async (response) => {
        console.log(response);
        if (response?.data?.success == false) {
          return alert(response?.data?.message ?? "");
        }

        setFeaturedProvider(response.data.data?.featured ?? {});
        setSupportProviders(response.data.data?.eap ?? []);
      })
      .catch((error) => {
        console.log("Get Support Connect Data Error: ", error);
        return alert(error);
      });
  };

  return (
    <>
      <EAPDetailsModal
        isOpen={eapOpen}
        onClose={() => setEapOpen(false)}
        showEADItem={selectedEAP}
      />
      <div
        className="w-screen min-h-screen"
        style={{
          background: `linear-gradient(45deg, rgba(255,255,255,0.8) 0%, rgba(255,255,255,0.8) 45%, ${
            profile?.company_id
              ? profile?.company_id?.company_primary_color
              : "rgba(81, 83, 245, 1)"
          } 150%)`,
        }}
      >
        <FadeIn delay={200}>
          <div className="container mx-auto flex flex-col justify-center items-center h-full w-full pb-24">
            <div className="w-full md:w-2/3 mt-12 px-6 md:px-0">
              <h4 className="text-2xl font-semibold">Support Connect</h4>

              {featuredProvider ? (
                <div className="bg-white border border-slate-300 rounded-xl flex flex-col justify-center items-center mt-4 py-4">
                  <img
                    className="w-56 h-auto object-contain"
                    src={featuredProvider?.image ?? ""}
                    alt="Featured Provider"
                  />
                  {featuredProvider?.options?.length > 0 ? (
                    <>
                      <h4 className="text-lg text-black font-medium">
                        {featuredProvider?.options[0]?.title ?? ""}
                      </h4>
                      <div className="mt-2 flex flex-row justify-center items-center">
                        <FaPhone size={20} className="text-mpPurple" />
                        <p className="ml-4 text-mpPurple text-xl font-medium">
                          {featuredProvider?.mobile}
                        </p>
                      </div>
                    </>
                  ) : null}
                </div>
              ) : (
                <></>
              )}
              <div className="grid grid-cols-2 gap-x-2 md:gap-x-3">
                {supportProviders?.map((provider) => (
                  <CommonEAPCard
                    key={provider?._id}
                    item={provider}
                    onClick={(item) => {
                      setSelectedEAP(item);
                      setEapOpen(true);
                    }}
                  />
                ))}
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </>
  );
};

export default SupportConnect;
